import React from 'react'
import { Button } from 'antd'
import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../auth'
import { usePricing } from '../../subscription/hooks'
import { formatPrice } from '../../subscription/pricing'
import { STARTER } from '../../subscription/tier'
import { SUBSCRIBE } from '../../user/permission'

/**
 * What Starter adds for a Website plan customer who needs another website, in one line: the websites and chat messages,
 * and the candidates it includes.
 */
export function useStarterSummary(): string | null {
    const { t } = useTranslation()
    const { data: pricing } = usePricing()
    const starter = pricing?.tiers[STARTER]

    if (!pricing || !starter?.monthly) {
        return null
    }

    return t(
        'Starter includes {{sites}} websites and {{messages}} chat messages per month, plus {{candidates}} candidates per month via WhatsApp, for {{price}} per month.',
        {
            candidates: starter.conversationLimit.toLocaleString('nl-NL'),
            sites: starter.siteLimit,
            messages: starter.messageLimit.toLocaleString('nl-NL'),
            price: formatPrice(starter.monthly.amount, pricing.currency),
        }
    )
}

export function UpgradeButton({ type = 'primary' }: { type?: 'primary' | 'default' }) {
    const { t } = useTranslation()
    const { can } = useAuth()

    if (!can(SUBSCRIBE)) {
        return null
    }

    return (
        <Link
            to="/settings"
            search={{ upgrade: true }}
        >
            <Button
                type={type}
                size="small"
            >
                {t('View Starter')}
            </Button>
        </Link>
    )
}
